import { SET_ERROR } from '.'

export const SetError: Types.ActionFactory<State.Error> = (payload) => ({
    type: SET_ERROR,
    payload,
})
